var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.50333 6.31371L0.606868 1.41725C0.40959 1.21997 0.408463 0.898537 0.609001 0.704575C0.653931 0.661118 0.680019 0.636749 0.696217 0.62219C0.907489 0.432307 1.22354 0.417405 1.4244 0.618267L6.31159 5.50545L11.2081 0.608985C11.4053 0.411708 11.7252 0.411708 11.9225 0.608985L12.0163 0.702837C12.2136 0.900115 12.2136 1.21996 12.0163 1.41724L7.11984 6.31371L12.0163 11.2102C12.2136 11.4075 12.2136 11.7273 12.0163 11.9246L11.9225 12.0184C11.7252 12.2157 11.4053 12.2157 11.2081 12.0184L6.31159 7.12197L1.41512 12.0184C1.21785 12.2157 0.896414 12.2168 0.702452 12.0163C0.658995 11.9714 0.634625 11.9453 0.620067 11.9291C0.430183 11.7178 0.415281 11.4018 0.616143 11.2009L5.50333 6.31371Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.eb8cef98.svg";
export { ForwardRef as ReactComponent };var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.50333 6.31371L0.606868 1.41725C0.40959 1.21997 0.408463 0.898537 0.609001 0.704575C0.653931 0.661118 0.680019 0.636749 0.696217 0.62219C0.907489 0.432307 1.22354 0.417405 1.4244 0.618267L6.31159 5.50545L11.2081 0.608985C11.4053 0.411708 11.7252 0.411708 11.9225 0.608985L12.0163 0.702837C12.2136 0.900115 12.2136 1.21996 12.0163 1.41724L7.11984 6.31371L12.0163 11.2102C12.2136 11.4075 12.2136 11.7273 12.0163 11.9246L11.9225 12.0184C11.7252 12.2157 11.4053 12.2157 11.2081 12.0184L6.31159 7.12197L1.41512 12.0184C1.21785 12.2157 0.896414 12.2168 0.702452 12.0163C0.658995 11.9714 0.634625 11.9453 0.620067 11.9291C0.430183 11.7178 0.415281 11.4018 0.616143 11.2009L5.50333 6.31371Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.eb8cef98.svg";
export { ForwardRef as ReactComponent };